import React from 'react';
import StarIcon from '@mui/icons-material/Star';
import StarHalfIcon from '@mui/icons-material/StarHalf';
import { type RestG2Rating } from '@bbkAdminUtils/api-client/rest-modals-cards-types';

import './g2-badge.scss';

type Props = {
  gRating: RestG2Rating;
};
const G2Badge: React.FC<Props> = (props) => {
  const { gRating } = props;

  function calcStars() {
    const starCount = gRating.rating;
    const halfStar = starCount % 1;
    const stars = [];

    // Count stars up to either the star count or stop at 5
    for (let i = 1; i <= Math.floor(starCount) && i <= 5; i += 1) {
      stars.push(<StarIcon style={{ color: '#F5A623' }} key={i} />);
    }
    if (halfStar) {
      stars.push(<StarHalfIcon style={{ color: '#F5A623' }} key="halfstar" />);
    }
    return stars;
  }

  return (
    <div className="g2-badge-component">
      <div className="g2-image">
        <div className="g2-alignment-container">
          <div className="stars">{calcStars()}</div>
          <img src={gRating.badge} alt="" className="g2-rating-image" />
        </div>
      </div>
    </div>
  );
};

export default G2Badge;
